import React from 'react';
import AssesmentTitleCard from './AssesmentTitleCard';
import { Card, Text } from '@ui/atoms';
import LazyImage from '@atoms/LazyImage';
import { borrowerFollowRecords } from '@helpers/constants';
import texts from './en.json';

const DealStructuring = () => {
    return (
        <div className="mt-0 mb-16 md:mb-20 xl:mb-36">
            <AssesmentTitleCard
                title={texts.DealStructuringStep}
                description={texts.DealStructuring}
            />

            <div className="flex flex-col mt-6 md:mt-0 xl:mt-10">
                <div className="relative">
                    <div className="flex justify-center items-center flex-col">
                        <Text
                            content="During the process of structuring a potential investment opportunity, the credit risk team identifies the risk associated and designs appropriate mitigants to minimize those risks through the application of various covenants and security packages. "
                            className="p4-regular md:block hidden my-8 mx-6 xl:mx-10"
                        />
                        <div className="flex items-center justify-center gap-2 mx-2 md:mx-6">
                            <Text
                                content={
                                    'Few covenant examples that altGraaf may require borrowers to follow'
                                }
                                className="p4-medium md:p2-medium text-left xl:text-center xl:m-10 px-2 text-primary-500"
                                htmlTag='h4'
                            />
                            <div className="flex relative justify-center items-center xl:w-24 xl:hidden">
                                <LazyImage
                                    src="/images/shield.svg"
                                    alt="logo"
                                    className="w-24 h-24"
                                />
                            </div>
                        </div>
                        <div
                            className="absolute z-1 min-w-[728px] min-h-[726px] w-full !bg-no-repeat !bg-top left-[36%] md:left-auto top-0 md:top-20 flex justify-center items-center"
                            style={{
                                background:
                                    'url(/images/CreditEvaluationProcess/spiral.svg)',
                                backgroundSize: '100% 100%',
                            }}
                        ></div>
                        <div className="flex-col gap-14 max-w-[1240px] px-8 mx-auto my-4 hidden md:flex ">
                            {borrowerFollowRecords.map((item, i) => (
                                <div
                                    className={`flex justify-around gap-6`}
                                    key={i}
                                >
                                    <Card className="max-w-[320px] z-10 md:max-w-[362px] xl:min-h-[88px] xl:max-w-[471px] h-auto flex items-center justify-center w-full p-4 md:p-6 bg-basicWhite shadow-xs border border-secondary-50">
                                        <Text
                                            content={item.first}
                                            className="p5-regular md:p4-regular text-basicBlack"
                                        />
                                    </Card>
                                    {item.image ? (
                                        <div className="relative hidden xl:flex justify-center items-center w-44 mx-6">
                                            <LazyImage
                                                src={item.image}
                                                alt="logo"
                                                className="xl:w-40 xl:h-40 absolute"
                                            />
                                        </div>
                                    ) : null}
                                    <Card className="max-w-[320px] z-10 md:max-w-[362px] xl:min-h-[88px] xl:max-w-[471px] h-auto flex items-center justify-center w-full p-4 md:p-6 bg-basicWhite shadow-xs border border-secondary-50">
                                        <Text
                                            content={item.second}
                                            className="p5-regular md:p4-regular text-basicBlack"
                                        />
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="flex-col px-6 mx-auto my-4 md:hidden flex gap-5 relative">
                    {borrowerFollowRecords.map((item, i) => (
                        <div
                            className={`flex justify-around flex-col gap-5`}
                            key={i}
                        >
                            <Card className="shadow-xs xl:min-h-[88px] w-full h-auto flex items-center justify-center opacity-70 bg-basicWhite text-left">
                                <Text
                                    content={item.first}
                                    className="p5-regular md:p4-regular text-basicBlack"
                                />
                            </Card>
                            <Card className="shadow-xs xl:min-h-[88px] w-full h-auto flex items-center justify-center opacity-70 bg-basicWhite text-left">
                                <Text
                                    content={item.second}
                                    className="p5-regular md:p4-regular text-basicBlack"
                                />
                            </Card>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DealStructuring;
